module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home"
  }, [_c('div', {
    staticClass: "jumbo-wrapper home"
  }, [_c('div', {
    staticClass: "jumbo-main home"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('h2', {
    staticClass: "t42"
  }, [_vm._v("SUBSTANTIAL REVENUE. LASTING IMPACT.")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("CREATE LASTING LEGACIES WITH AN ENGRAVED BRICK FUNDRAISER")]), _vm._v(" "), _c('div', {
    staticClass: "learn-more"
  }, [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/proven-benefits",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("LEARN MORE")])])], 1)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row home-icons"
  }, [_c('router-link', {
    staticClass: "col-sm-12 col-xs-12 col-md-6",
    attrs: {
      "to": "/unmatched-quality",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "icon-content home-quality"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "rounded-content text-center"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("UNMATCHED QUALITY")]), _vm._v(" "), _c('p', [_vm._v("Hand-Crafted for Lasting Impact!")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "col-sm-12 col-xs-12 col-md-6",
    attrs: {
      "to": "/fundraising-toolkit",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "icon-content home-toolkit"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "rounded-content text-center"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("FUNDRAISING TOOLKIT")]), _vm._v(" "), _c('p', [_vm._v("All the Tools for Your Success!")])])]), _vm._v(" "), _c('img', {
    staticClass: "orange-callout",
    attrs: {
      "src": "images/Home-Page/homeorangecallout.png",
      "alt": "Free Brick Fundraiser Website"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-content home"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('div', {
    staticClass: "home-products"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "home-products-right"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/product-guide",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("PRODUCT GUIDE")])])], 1)])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "home-howto",
    attrs: {
      "to": "/how-it-works",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 howto-heading"
  }, [_vm._v("\n                    How to Get Started\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "howto-content"
  }, [_c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content one"
  }, [_c('p', [_vm._v("\n                            REQUEST OUR"), _c('br'), _vm._v("\n                            FUNDRAISING TOOLKIT\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle one"
  }, [_c('span', [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider left"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content two"
  }, [_c('p', [_vm._v("\n                            SUBMIT YOUR"), _c('br'), _vm._v("\n                            BRICK FUNDRAISER"), _c('br'), _vm._v("\n                            REGISTRATION\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle two"
  }, [_c('span', [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider left"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content three"
  }, [_c('p', [_vm._v("\n                            LAUNCH YOUR"), _c('br'), _vm._v("\n                            FUNDRAISER\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle three"
  }, [_c('span', [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider leftmost"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottommost"
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('testimonials-carousel', [_c('div', {
    staticClass: "carousel-inner quote-slider",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "quote-slider-item item active"
  }, [_c('p', {
    staticClass: "slider-text"
  }, [_vm._v("\n                        “We found our personal paver program to be an extremely positive fan experience that could very possibly create a lifetime connection/loyalty to the team. The realization that future generations can visit the stadium and see a place of their family legacy creates huge personal ties to these programs.”\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "quote-author"
  }, [_c('span', [_vm._v("Jay Souers, Vice President of Sponsorship Sales")]), _vm._v(" "), _c('span', [_vm._v("Indianapolis Colts")]), _vm._v(" "), _c('span', [_vm._v("Phase I: 2009 | Phase II: 2014")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote-slider-item item"
  }, [_c('p', {
    staticClass: "slider-text"
  }, [_vm._v("\n                        “Our partnership with Fund Raisers, Ltd. has been very positive. I would encourage any company that is looking to raise revenue for a project to partner with Fund Raisers, Ltd. on a tile or brick program. Their professionalism and service made the entire project very simple, smooth and profitable.”\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "quote-author"
  }, [_c('span', [_vm._v("Danny Dann, Director, Sponsorship Services")]), _vm._v(" "), _c('span', [_vm._v("San Francisco Giants")]), _vm._v(" "), _c('span', [_vm._v("Phase I: 2000 | Phase II: 2002 | Phase III: 2008 | Phase IV: 2011")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote-slider-item item"
  }, [_c('p', {
    staticClass: "slider-text"
  }, [_vm._v("\n                        “This project has far exceeded our expectations in terms of creating a tangible display of the emotional connection between our fans and the White Sox team and organization. Aethetically and finacially the project was a success. In large part our success is attributed to Fund Raisers, Ltd. We know we selected the best partner in working with them.”\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "quote-author"
  }, [_c('span', [_vm._v("Christine O'Reilly, Senior Director of Community Relations")]), _vm._v(" "), _c('span', [_vm._v("Chicago White Sox")]), _vm._v(" "), _c('span', [_vm._v("Phase I: 2008 | Phase II: 2009 | Phase III: 2015")])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-ourway"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 ourway-motto"
  }, [_c('strong', {
    staticClass: "strong-quote"
  }, [_vm._v("The Fund Raisers, Ltd. Advantage")])])]), _vm._v(" "), _c('div', {
    staticClass: "row home-stats"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-4 home-engraving text-center"
  }, [_c('div', {
    staticClass: "stats-content"
  }, [_c('h2', [_vm._v("32+")]), _vm._v(" "), _c('p', [_vm._v("YEARS OF EXPERIENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-4 home-website text-center"
  }, [_c('div', {
    staticClass: "stats-content"
  }, [_c('h2', [_vm._v("2,000+")]), _vm._v(" "), _c('p', [_vm._v("ENGRAVED BRICK PROJECTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-4 home-roadmap text-center"
  }, [_c('div', {
    staticClass: "stats-content"
  }, [_c('h2', [_vm._v("750K+")]), _vm._v(" "), _c('p', [_vm._v("BRICKS ENGRAVED")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-products-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "371",
      "src": "images/Home-Page/homeproducts.png",
      "alt": "Products"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center products"
  }, [_vm._v("\n                            No Upfront Costs\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row products-list"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("No Minimum Order")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("Free Personalized"), _c('br'), _vm._v("Marketing Sample!")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("Free Shipping")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testimonials testimonials-home"
  }, [_vm._v("\n            100+ PROFESSIONAL AND COLLEGIATE SPORTS TEAMS AND FACILITIES\n            "), _c('br'), _vm._v("AND THOUSANDS OF COMMUNITY FUNDRAISERS\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76e45ac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = g3LR
// module chunks = 1